import { getEffectiveOwnerId } from "./helpers";

export const hasWarehousePermission = (user, warehouseId, permissionName) => {
  if (!user || warehouseId == null || !permissionName) return false;

  const wid = String(warehouseId);
  const approved = Array.isArray(user?.user_approved_warehouses)
    ? user.user_approved_warehouses
    : [];

  const entry = approved.find((w) => String(w?.warehouse_id) === wid);
  if (!entry) return false;

  const perms = Array.isArray(entry?.permissions) ? entry.permissions : [];
  return perms.some((p) => p?.name === permissionName);
};

export const getAccessibleWarehouseIds = (user, permissionName) => {
  const set = new Set();
  if (!user) return set;
  const approved = Array.isArray(user?.user_approved_warehouses)
    ? user.user_approved_warehouses
    : [];
  const rawOwner = getEffectiveOwnerId(user);
  const ownerId = rawOwner != null ? String(rawOwner) : null;

  approved.forEach((entry) => {
    const wid = String(entry?.warehouse_id);
    const currentUserId = entry?.warehouse?.current_user_id;
    if (
      ownerId != null &&
      currentUserId != null &&
      String(currentUserId) === ownerId
    ) {
      set.add(wid);
      return;
    }
    if (!permissionName) return;
    const perms = Array.isArray(entry?.permissions) ? entry.permissions : [];
    if (perms.some((p) => p?.name === permissionName)) {
      set.add(wid);
    }
  });
  return set;
};
